
import * as React from "react";
import {getContainer} from "../../ioc/IOCSetup";
import {LoadingViewState, RouterView} from "../RouterView";
import {Form, FormListener} from "../form/Form";
import {RouteComponentProps, withRouter} from "react-router";
import {Fragment} from "react";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {InternalSettings} from "../../http/protocol";
import {InternalSettingsService} from "../../services/InternalSettingsService";


interface Props extends RouteComponentProps {

}

interface State extends LoadingViewState{
    settings?: InternalSettings;
    validationMap? : any;
    emailRequired? : boolean;

}

export class SettingsInternalView extends RouterView<Props,State> implements FormListener<InternalSettings>{

    settingsService: InternalSettingsService;

    constructor(props:Props) {
        super(props);

        this.settingsService = getContainer().getInternalSettingsService();

        this.state = {validationMap : {}, loading : true, emailRequired : false};
    }

    loadContent(): Promise<any> | undefined {
        return this.settingsService.getSettings().then((data:InternalSettings) => {
            let emailRequired:boolean = false;
            if(data.paymentNotifyDeposit || data.paymentNotifyInstantWithdraw || data.paymentNotifyWithdrawApprovementNeeded) {
                emailRequired = true;
            }
            this.setState({settings:data, emailRequired: emailRequired})
        })
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        super.componentDidUpdate(prevProps, prevState);

    }

    formDidUpdate(formModel:InternalSettings, validationMap : any) {
        let emailRequired:boolean = false;
        if(formModel.paymentNotifyInstantWithdraw || formModel.paymentNotifyDeposit || formModel.paymentNotifyWithdrawApprovementNeeded) {
            emailRequired = true;
        }
        this.setState({ settings : formModel, validationMap : validationMap, emailRequired : emailRequired});
    }

    onSubmit():Promise<any> {
        if(!this.state.settings) {
            return Promise.reject("Unable to save settings");
        }
        console.log("saving settungs: ", this.state.settings);

        return this.settingsService.saveSettings(this.state.settings).catch(err=>{
            throw new Error("Unable to create/save settings");
        });
    }

    onSubmitError(){}

    getTitle() : string {
        return "Internal Settings";
    }

    renderContent() {
        if(!this.state.settings || this.state.emailRequired === undefined) {
            return <span></span>
        }
        return(
            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.settings} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Settings was updated successfully"/>

                                    <FormGroup className="form-group mb-3" model={"facebookAppSecret"}>
                                        <label>Facebook App Secret</label>
                                        <FormInput className="form-control" model={"facebookAppSecret"} type="text" id="paymentNotificationEmail" />
                                        <span className={"help-block"}>API key that is used to call the Facebook API from the backend. This can be found in Facebook Developer Console</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model={"paymentNotificationEmail"}>
                                        <label>Notification email</label>
                                        <FormInput className="form-control" model={"paymentNotificationEmail"} type="text" id="paymentNotificationEmail"/>
                                        <span className={"help-block"}>Email for receiving payment notifications separated with a single space</span>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="paymentNotifyDeposit">
                                        <FormInput className="custom-control-input" model={"paymentNotifyDeposit"} id="paymentNotifyDeposit" type="checkbox"/>
                                        <label htmlFor="paymentNotifyDeposit" className={"custom-control-label"}>Deposit Notification</label>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="paymentNotifyInstantWithdraw">
                                        <FormInput className="custom-control-input" model={"paymentNotifyInstantWithdraw"} id="paymentNotifyInstantWithdraw" type="checkbox"/>
                                        <label htmlFor="paymentNotifyInstantWithdraw" className={"custom-control-label"}>Instant Withdraw Notification</label>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="paymentNotifyWithdrawApprovementNeeded">
                                        <FormInput className="custom-control-input" model={"paymentNotifyWithdrawApprovementNeeded"} id="paymentNotifyWithdrawApprovementNeeded" type="checkbox"/>
                                        <label htmlFor="paymentNotifyWithdrawApprovementNeeded" className={"custom-control-label"}>Withdraw Approval Notification</label>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="weeklySummaryEmail">
                                        <FormInput className="custom-control-input" model={"weeklySummaryEmail"} id="weeklySummaryEmail" type="checkbox"/>
                                        <label htmlFor="weeklySummaryEmail" className={"custom-control-label"}>Weekly Summary Email</label>
                                    </FormGroup>
                                    <FormGroup className="custom-control custom-checkbox" model="creditEnabled">
                                        <FormInput className="custom-control-input" model={"creditEnabled"} id="creditEnabled" type="checkbox"/>
                                        <label htmlFor="creditEnabled" className={"custom-control-label"}>Credit Enabled</label>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model={"weeklySummaryEmailRecipients"}>
                                        <label>Weekly summary email recipients</label>
                                        <FormInput className="form-control" model={"weeklySummaryEmailRecipients"} type="text" id="weeklySummaryEmailRecipients"/>
                                        <span className={"help-block"}>Emails to receive weekly summary separated with a single space</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model={"matiSecretString"}>
                                        <label>Mati Secret</label>
                                        <FormInput className="form-control" model={"matiSecretString"} type="text" id="matiSecretString" />
                                        <span className={"help-block"}>Mati secret.</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model={"blockedCountries"}>
                                        <label>Blocked countries</label>
                                        <FormInput className="form-control" model={"blockedCountries"} type="text" id="blockedCountries"/>
                                        <span className={"help-block"}>Block is applied when loading the site. Country codes in ISO-3166-1 Alpha-2 format. Separate with single space. Example (USA, Germany & Sweden): US DE SE</span>
                                    </FormGroup>

                                    <FormGroup className="custom-control custom-checkbox" model="verifyIpAddresses">
                                        <FormInput className="custom-control-input" model={"verifyIpAddresses"} id="verifyIpAddresses" type="checkbox"/>
                                        <label htmlFor="verifyIpAddresses" className={"custom-control-label"}>Check IP Address</label><br/>
                                        <span className={"help-block"}>Check the IP address against abuse & fraud IP lists when a user registers. If above risk level then the registration will be blocked.</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model={"maxIpAddressRiskLevel"}>
                                        <label>Max IP Address Risk Level</label>
                                        <FormInput className="form-control" model={"maxIpAddressRiskLevel"} type="text" id="maxIpAddressRiskLevel"/>
                                        <span className={"help-block"}>Max acceptable risk level for IP addresses. 1 to 5 where 1 is lowest risk. Only applicable if 'Check IP Address' is enabled. If set to 5 then all risk levels are allowed. 1 is most stringent. Recommended: 3</span>
                                    </FormGroup>

                                    <FormGroup className="form-group mb-3" model={"registrationIpBlockTime"}>
                                        <label>Registration IP Address Block Time</label>
                                        <FormInput className="form-control" model={"registrationIpBlockTime"} type="text" id="registrationIpBlockTime"/>
                                        <span className={"help-block"}>When a new user signs up, block his IP for this many minutes for new signups to avoid spam registrations. Set to 0 to disable. Max: 60. Recommended: 15</span>
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Settings</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>


            </Fragment>
        )
    }

}

export default withRouter(SettingsInternalView);